import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface ComplaintInternalMessageUpsertState extends ApiState {
  complaintInternalMessageId?: string
}

export default requestReducer<ComplaintInternalMessageUpsertState>('COMPLAINT_INTERNAL_MESSAGE_UPSERT')
